import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form1118Service {

  constructor(private http: HttpClient) { }

  /**
   * Save Form 1118 Override Data.
   * globalService.globalParams must be hydrated via hydrateGlobalParamsFromContext
   * before calling this method — it provides tax_year, scenario, jcd_key,
   * scenarioCode, is_issue_key_enabled, etc.
   */
  saveForm1118Override(
    baseUrl: string,
    formData: any,
    details: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);

    params.clob_data = JSON.stringify(details);
    params.clob_settings = JSON.stringify(formData);
    params.process_name = 'FORM1118_SAVE';
    params.filing_group_key = filterParams.filing_group_key;
    params.filer_entity_key = filterParams.filer_entity_key;

    // Normalize underscore variant from filterParams if camelCase is missing
    if (!params.scenarioCode && filterParams.scenario_code) {
      params.scenarioCode = filterParams.scenario_code;
    }

    if (!params.checkLockedbj) {
      const checkLockedbj = [{
        scenario_key: params.scenario
      }];
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    });

    const url = baseUrl + '/saveJsonObject?action_code=fo9xk2';

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Load dropdown data for schedules, lines, columns
   * @param baseUrl - Base URL for API
   * @param scheduleKey - Schedule key to filter data (null for ADD mode initial load)
   * @param globalService - Global service params
   * @returns Observable with dropdown data
   */
  loadDropdownData(
    baseUrl: string,
    scheduleKey: number | null,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams, {
      action_code: 'y7xpnk'
    });

    if (scheduleKey !== null && scheduleKey !== undefined) {
      params.schedule_key = scheduleKey;
    }

    const url = baseUrl + '/loadJsonObject';

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  /**
   * Load basket dropdown data
   * @param baseUrl - Base URL for API
   * @param globalService - Global service params
   * @returns Observable with basket data
   */
  loadBasketData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams, {
      action_code: '1x4adz'
    });

    const url = baseUrl + '/loadJsonObject';

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  /**
   * Load SIC Code dropdown data
   * @param baseUrl - Base URL for API
   * @param globalService - Global service params
   * @returns Observable with SIC code data
   */
  loadSICCodeData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams, {
      action_code: 'e8jfqu'
    });

    const url = baseUrl + '/loadJsonObject';

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  /**
   * Load lock status
   * @param baseUrl - Base URL for API
   * @param scenario - Scenario parameter
   * @param jcdKey - JCD Key parameter
   * @param globalService - Global service params
   * @returns Observable with lock status
   */
  loadLockStatus(
    baseUrl: string,
    scenario: string,
    jcdKey: number,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams, {
      action_code: 'n10cpv',
      p_scenario: scenario,
      p_jcd_key: jcdKey
    });

    const url = baseUrl + '/loadJsonObject';

    return this.http.get<any>(url, { params, withCredentials: true });
  }
}

